<template>
  <div id="achieve">
    <div class="bg-color-black">
    <div class="d-flex pt-2 pl-2">
      <router-link to='/achievement'>
         <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">成果转化</span>
        </span>
      </router-link>
    </div>
    <div class="up">
      <div class="item" v-for="(item,pi) in titleItem" :key="pi">
        <p style="font-size: 16px;color:#5cd9e8;text-align: center">
          <i class="icon-dot" :style="{'color':color[pi]}"></i>{{item.name}}</p>
        <div class="d-flex">
          <span>{{item.value}}<i>{{tit[pi]}}</i></span>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
// import CenterChart from "@/components/echart/center/centerChartRate";
import sciApi from '@/api/index.js'
export default {
  data () {
    return {
      tag:'',
      Num:{
         '技术成果':0,
        '技术需求':0,
        '技术经纪人':0,
        '技术转移机构':0,
        '技术投资机构':0,
      },
      color:['#eacf19','#8378ea','#e7bcf3','#fb7293','#ff9f7f',],
      tit:["项","项","人","家","家"],
      achievements:[],
      titleItem:[],
    };
  },
  watch:{
    setregion:{
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val
      }
    },
    tag:{
      immediate: false,
      deep: true,
      handler(val) {
        console.log(val,'val')
        this.init().then(()=>{
          let num=[]
          for (let key in this.Num){
            num.push({ name:key,
              value:this.Num[key]})
          }
          this.titleItem = num
        })
      }
    }
  },
  created() {

  },
  computed:{
    setregion() {
      // console.log(this.$store.state.region)
      return this.$store.state.region
    }
  },
  mounted() {
    this.tag=''
    this.init().then(()=>{
      let num=[]
      for (let key in this.Num){
        num.push({ name:key,
          value:this.Num[key]})
      }
      this.titleItem = num
    })
  },
  methods:{
    async init(){
      const that = this;
      await sciApi.selectScience({pageSize: 1000,pageNum: 1}).then((data)=>{
        // data 就是接口返回值
        this.achievements = data.list || []
        if(this.tag!==''){
          this.achievements.forEach((item) => {
            if(item.mapAreaDisplay == that.tag)
            {
              that.Num[item.level1Display] += parseInt(item.mapNum);
            }else {
              that.Num[item.level1Display] = 0;
            }
          })
        }
        else {
          this.achievements.forEach((item) => {
            that.Num[item.level1Display] += parseInt(item.mapNum);
          })
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
#achieve {
  padding: 0.2rem;
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 0 0.1rem;
    //justify-content: space-around;
    .item {
      float: left;
      padding-top: 0.2rem;
      width: 32%;
      margin-right: 0.1rem;
      margin-top: 0.1rem;
      height: auto;
      background:#142957;
      border-radius: 0.125rem;
    }
    .item:nth-child(3){
      border-right: 0;
      margin-right: 0;
    }
    .item span{
      font-size: 30px;
      color: #fff;
      text-align: center;
      height: .625rem;
      line-height: .625rem;
      width: 100%;
    }
    .item span i{
      font-style: normal;
      color: #5cd9e8;
      font-size: 16px;
      margin-left: 5px;
    }
  }
}
</style>